import { Button } from "@/components/ui/button";
import Icons from "@/components/Icons";
import { useEffect, useState, useRef } from "react";
import type { GameData } from "@/interfaces";
import { useAnalytics } from "@/hooks/useAnalytics";
import {
  getCheckoutAnalyticsData,
  clearCheckoutAnalyticsData,
  safeTrack,
} from "@/services/AnalyticsService";

const FailedPage = () => {
  const [gameData, setGameData] = useState<GameData | null>(null);
  const { track, isEnabled } = useAnalytics();
  const hasTrackedFailedRef = useRef(false);

  useEffect(() => {
    const storedGameData = sessionStorage.getItem("gameData");
    if (!storedGameData) return;
    try {
      setGameData(JSON.parse(storedGameData));
    } catch {
      sessionStorage.removeItem("gameData");
    }
  }, []);

  // Track failed purchase
  useEffect(() => {
    if (!isEnabled || hasTrackedFailedRef.current) {
      return;
    }
    hasTrackedFailedRef.current = true;
    const urlParams = new URLSearchParams(window.location.search);
    const reason = urlParams.get('error') || 'unknown';

    const analyticsData = getCheckoutAnalyticsData();
    const paymentMethod = analyticsData.payment_method || urlParams.get('payment_method') || 'card';

    safeTrack(track, 'purchase_failed', {
      ...analyticsData,
      reason,
      payment_method: paymentMethod,
    });

    // Clear stored analytics data after tracking
    clearCheckoutAnalyticsData();
  }, [isEnabled, track]);

  const handleTryAgain = () => {
    // Check for native return URL from wrapped flow (native apps)
    const nativeReturnUrl = sessionStorage.getItem('native_return_url');
    
    if (nativeReturnUrl) {
      // Clear the stored URL to avoid reusing it
      sessionStorage.removeItem('native_return_url');
      // Redirect to native app using the provided return URL
      window.location.href = nativeReturnUrl;
      return;
    }

    // Redirect back to the checkout form, preserving URL parameters
    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams(currentUrl.search);
    
    // Remove status-related parameters to start fresh
    params.delete('success');
    params.delete('error');
    params.delete('payment_intent_status');
    params.delete('redirect_status');
    
    // Build checkout URL with preserved parameters
    const checkoutUrl = `${currentUrl.origin}/checkout${params.toString() ? '?' + params.toString() : ''}`;
    window.location.href = checkoutUrl;
  };

  return (
    <>
      <section className="flex flex-col pt-[17px] pb-[21px] h-full landscape:justify-between">
        {/* <p className="px-5 text-[#A2998B] text-[14px] mb-[75px] landscape:mb-1">
        {gameData?.checkout_title}
      </p> */}

        <div className="flex flex-col items-center text-center px-3 w-full h-full landscape:flex-1">
          <div className="flex-grow flex flex-col justify-center items-center landscape:flex-1">
            <div className="h-[156px] w-[156px] mb-5 landscape:h-[101px] landscape:w-[106px] landscape:mb-2 flex items-center justify-center">
              <Icons type="fail" size={156} className="landscape:!w-[101px] landscape:!h-[106px]" />
            </div>
            <h1 className="text-[20px] text-[#423F3B] font-bold mb-[12px] landscape:mb-2">
              Payment Failed
            </h1>
            <div className="text-[#A2998B]">
              <p className="flex items-center justify-center gap-1 ">
                <Icons type="info" size={15} />
                Something went wrong.
              </p>
              <p>Try again or use a different paying method.</p>
            </div>
          </div>
          <div className="landscape:flex-shrink-0 w-full max-w-xs landscape:max-w-sm landscape:mx-auto">
            <Button
              variant="backToGame"
              onClick={handleTryAgain}
              className="w-full landscape:mb-2"
            >
              Try A Different Method
            </Button>
          </div>
        </div>
      </section>
      {/* <section className="flex flex-col items-center justify-center h-full space-y-10 text-center">
        <Icons type="fail" size={156} />
        <h1 className="mt-4 text-xl text-[#423F3B] mb-5">Payment Failed</h1>
        <div className="text-[#A2998B] mb-11">
          <p className="flex items-center justify-center gap-1">
            <Icons type="info" size={15} />
            Something went wrong.
          </p>
          <p>Try again or use a different paying method.</p>
        </div>

        <Button
          variant="backToGame"
          onClick={handleTryAgain}
          className="w-full max-w-xs"
        >
          Try A Different Method
        </Button>
      </section> */}
    </>
  );
};

export default FailedPage;
